var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"slider-color":"primary","color":"white"}},_vm._l((_vm.filteredRoles),function(item){return _c('v-tab',{key:item.title,attrs:{"to":{ name: item.route }}},[_vm._v(_vm._s(item.title))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }